import '@style/customer.scss';
import creator from '@utils/creator.js';

import CustomerLoyalty from '@components/CustomerLoyalty.js';
import CustomerPreference from '@components/CustomerPreference.js';
import FamilyProfile from '@components/FamilyProfile.js';
import Replenishemt from '@components/Replenishemt';

function ClrzAppInit() {
	ClrzApp.CustomerLoyalty = creator('.js-customer-loyalty', CustomerLoyalty);
	ClrzApp.CustomerPreference = creator(
		'.js-customer-preference',
		CustomerPreference,
	);
	ClrzApp.FamilyProfile = creator('.js-family-profile', FamilyProfile);
	customElements.define('replenishemt-order', Replenishemt);
}

ClrzAppInit();
